import { useMemo } from 'react';

import { useCore } from '@phoenix/core/frontend/shared/feature/context/core.context';

export const useQueryContextMemo = (url?: string) => {
  const {
    auth: { user },
  } = useCore();

  return useMemo(
    () => ({
      ...(user?.country && {
        fetchOptions: {
          headers: {
            'x-accept-country': user?.country,
          },
        },
      }),
      ...(url && { url }),
    }),
    [user, url]
  );
};
